// 各設定用のinterfaceを個別に定義してたが、webpack-dev-serverが変更を検出しない問題あり.
// (interface以外の箇所から直接参照しないと対象にならない？現状未解決.)
// 開発効率が悪すぎるので、設定は全て本ファイルに記載する事にする.
// ・原則、入れ子で定義.(配列はArray<{field: type}>で指定可能.)
// ・設定内で繰り返し使われる構造がある場合は、本ファイル内にinterfaceを定義.

export interface IConfiguration {
  restriction: IRestrictionConfiguration;
  behavior: IBehaviorConfiguration;
  style: IStyleConfiguration;
  routing: IRoutingConfiguration;
  system: ISystemConfiguration;
  wording: IWordingConfiguration;
  debug: IDebugConfiguration;
  dangerZone: IDangerZoneConfiguration;
}

export type RestrictionType = "aiPhrase";

export interface IRestrictionConfiguration {
  user: { [key in RestrictionType]: IUserRestrictionConfiguration };
}

export interface IUserRestrictionConfiguration extends IEnableConfiguration {
  user: IUserRestrictionCodesConfiguration;
  profession: IUserRestrictionCodesConfiguration;
  // TODO: department追加.(必要になってから.)
}

export interface IUserRestrictionCodesConfiguration extends IEnableConfiguration {
  allowed: string[];
  // TODO: 不許可リスト(disallowed)追加.(必要になってから.)
}

export interface IBehaviorConfiguration {
  document: IBehaviorDocumentConfiguration;
  format: IBehaviorFormatConfiguration;
  patient: IBehaviorPatientConfiguration;
  departmentGroup: IBehaviorDepartmentGroupConfiguration;
  department: IBehaviorDepartmentConfiguration;
  profession: IBehaviorProfessionConfiguration;
  localhost: IBehaviorLocalhostConfiguration;
  user: IBehaviorUserConfiguration;
  reception: IBehaviorReceptionConfiguration;
  authentication: IBehaviorAuthenticationConfiguration;
  closer: IEnableConfiguration;
  collaboration: IBehaviorCollaborationsConfiguration;
  header: IBehaviorHeaderConfiguration;
  configuration: IEnableConfiguration;
  fixedPhrase: IBehaviorFixedPhraseConfiguration;
  setting: IBehaviorSettingConfiguration;
  wizard: IBehaviorWizardConfiguration;
  emailAccount: IEnableConfiguration;
}

export interface IBehaviorDocumentConfiguration {
  editor: IBehaviorDocumentEditorConfiguration;
  viewer: IBehaviorDocumentViewerConfiguration;
  list: IBehaviorDocumentListConfiguration;
  registerNewDocuments: IBehaviorDocumentRegisterNewDocumentsConfiguration;
  entities: IBehaviorDocumentEntityConfiguration;
  previewWindow: IBehaviorDocumentPreviewWindowConfiguration;
  processor: IBehaviorDocumentProcessorConfiguration;
  postPrinting: IBehaviorDocumentPostPrintingConfiguration;
}

export interface IBehaviorDocumentPostPrintingConfiguration {
  applications: IBehaviorDocumentPostPrintingApplicationConfiguration[];
}

export interface IBehaviorDocumentPostPrintingApplicationConfiguration extends IEnableConfiguration {
  executeCondition: IBehaviorDocumentPostPrintingApplicationExecuteConditionConfiguration;
  modulePath: string;
  parameter: string;
}

export interface IBehaviorDocumentPostPrintingApplicationExecuteConditionConfiguration {
  printerSelection: ExecuteConditionPrinterSelectionKindKeys;
}

export type ExecuteConditionPrinterSelectionKindKeys = "any" | "withoutPrinterSelection" | "withPrinterSelection";

export type NewObjectKeys =
"NewArrowLine" |
"NewBoxLine" |
"NewCircle" |
"NewCross" |
"NewImage" |
"NewLine" |
"NewNewPage" |
"NewPolyline" |
"NewTag" |
"NewText" |
"NewTriangle" |
"NewInvisibleArrowLine" |
"NewInvisibleBoxLine" |
"NewInvisibleCircle" |
"NewInvisibleCross" |
"NewInvisibleLine" |
"NewInvisiblePolyline" |
"NewInvisibleTriangle";

export type NewSignObjectKeys =
"NewPen";

export type DateSelectorCustomButtonType =
"fromToday";

export interface IBehaviorDocumentEditorConfiguration {
  shouldConfirmToLeavePage: boolean;
  confirmMessageToLeavePage: string;
  confirmMessageToCloseWindow: string;
  closeWindowConfirmation: ICloseWindowConfirmationConfiguration;
  objectLazyDrawer: IBehaviorDocumentEditorObjectLazyDrawerConfiguration;
  patientProfile: IBehaviorDocumentEditorPatientProfileConfiguration;
  hisInformationUpdate: IBehaviorDocumentEditorHisInformationUpdateConfiguration;
  hisInformationUpdateMenu: IBehaviorDocumentEditorHisInformationUpdateMenuConfiguration;
  hisInformationSelector: IBehaviorDocumentEditorHisInformationSelectorConfiguration;
  userDefinition: IBehaviorDocumentEditorUserDefinitionConfiguration;
  handles: IBehaviorDocumentEditorHandlesConfiguration;
  grid: ISizeConfiguration;
  extraPageAdditionAtInitialization: IBehaviorDocumentEditorExtraPageAdditionAtInitializationConfiguration;
  chainedObjectUpdation: IBehaviorDocumentEditorChainedObjectUpdationConfiguration;
  externalScript: IBehaviorDocumentEditorExternalScriptConfiguration;
  objectLocator: IBehaviorDocumentEditorObjectLocatorConfiguration;
  imageDropper: IBehaviorDocumentEditorImageDropperConfiguration;
  imageEditor: IBehaviorDocumentEditorImageEditorConfiguration;
  eraser: IBehaviorDocumentEditorEraserConfiguration;
  shouldConfirmCalculationErrorToRegisterDocument: boolean;
  contents: IBehaviorDocumentEditorContentsConfiguration;
  panes: IBehaviorDocumentEditorPanesConfiguration;
  pageNavigator: IBehaviorDocumentEditorPageNavigatorConfiguration;
  mischievousObjects: IBehaviorDocumentEditorMischievousObjectsConfiguration;
  calculationMenu: IEnableConfiguration;
  menu: IBehaviorDocumentEditorMenusConfiguration;
  notifications: IBehaviorDocumentEditorNotificationsConfiguration;
  designatedDoctorNumber: IBehaviorDocumentEditorDesignatedDoctorNumberConfiguration;
  registerer: IBehaviorDocumentEditorRegistererConfiguration;
  deleter: IBehaviorDocumentEditorDeleterConfiguration;
  validator: IBehaviorDocumentEditorValidatorsConfiguration;
  injector: IBehaviorDocumentEditorInjectorConfiguration;
  conflict: IBehaviorDocumentEditorConflictConfiguration;
  formatUpdate: IEnableConfiguration;
  objects: IBehaviorDocumentEditorObjectsConfiguration;
  newObjects: IBehaviorDocumentEditorNewObjectsConfiguration;
  sign: IBehaviorDocumentEditorSignConfiguration;
  previewMenu: IBehaviorDocumentEditorPreviewMenuConfiguration;
  documentAttributes: IBehaviorDocumentEditorDocumentAttributesConfiguration;
  externalMenus: IExternalMenuItemConfiguration[];
  externalTemplates: IBehaviorDocumentEditorExternalTemplatesConfiguration;
  quotation: IBehaviorDocumentEditorQuotationConfiguration;
  preview: IBehaviorDocumentEditorPreviewConfiguration;
  naturalText: IEnableConfiguration;
  multiple: IBehaviorDocumentEditorMultipleConfiguration;
  singleEntry: IEnableConfiguration;
  departmentGroup: IBehaviorDocumentEditorDepartmentGroupConfiguration;
  shouldConfirmRegisterRevisedChainDocuments: boolean;
  temporaryNote: IBehaviorDocumentEditorTemporaryNoteConfiguration;
  management: IBehaviorDocumentEditorManagementConfiguration;
  collaboration: IBehaviorDocumentEditorCollaborationConfiguration;
  injectedData: IEnableConfiguration;
}

export interface IBehaviorDocumentEditorCollaborationConfiguration {
  shouldRegisterCollaborationParameter: boolean;
}

export interface IBehaviorDocumentEditorManagementConfiguration extends IEnableConfiguration {
  shouldSkipWhenTemporaryRegistration: boolean;
  restriction: IBehaviorDocumentEditorManagementRestrictionConfiguration;
  approver: IBehaviorDocumentEditorManagementApproverConfiguration;
}

export interface IBehaviorDocumentEditorManagementRestrictionConfiguration {
  professionCodes: string[];
}

export interface IBehaviorDocumentEditorManagementApproverConfiguration {
  professionCodes: string[];
  enableAutoSelection: boolean;
}

export interface IBehaviorDocumentEditorObjectLazyDrawerConfiguration {
  initialDrawItemMax: number;
  intervalToDrawItemAsMsec: number;
  itemCountPerDraw: number;
}

export interface IBehaviorDocumentEditorPatientProfileConfiguration extends IEnableConfiguration {
  updateKind: PatientProfileUpdateKinds;
  isEditable: boolean;
}

export interface IBehaviorDocumentEditorHisInformationUpdateConfiguration {
  autoUpdateOnEditStart: IDocumentTypeKindSpecifiableConfiguration;
  shouldUpdateEmptyObjectOnlyOnEditStart: IDocumentTypeKindSpecifiableConfiguration;
  shouldUpdateAllHisItemsInExtraSectionWhenQuote: IDocumentTypeKindSpecifiableConfiguration;
}

export interface IBehaviorDocumentEditorHisInformationUpdateMenuConfiguration {
  shouldShowUpdateEmptyObjectOnlyButton: boolean;
}

export interface IBehaviorDocumentEditorHisInformationSelectorConfiguration extends IDisplayCountPerPageConfiguration {
  departmentFilter: IEnableConfiguration;
  defaultSort: IBehaviorDocumentEditorHisInformationSelectorDefaultSortConfiguration;
}

export interface IBehaviorDocumentEditorHisInformationSelectorDefaultSortConfiguration {
  disease: IHisInformationSelectorSortConfiguration;
  hospitalization: IHisInformationSelectorSortConfiguration;
  operation: IHisInformationSelectorSortConfiguration;
}

export interface IHisInformationSelectorSortConfiguration {
  key: string;
  isDescending: boolean;
}

export interface IBehaviorDocumentEditorUserDefinitionConfiguration extends IDisplayCountPerPageConfiguration {
  filter: IBehaviorDocumentEditorUserDefinitionFilterConfiguration;
}

export interface IBehaviorDocumentEditorUserDefinitionFilterConfiguration {
  default: IBehaviorDocumentEditorUserDefinitionFilterDefaultConfiguration;
}

export interface IBehaviorDocumentEditorUserDefinitionFilterDefaultConfiguration {
  shouldDistinguishCharacterWidth: boolean;
}

export interface IBehaviorDocumentEditorHandlesConfiguration {
  resize: IBehaviorDocumentEditorHandlesResizeConfiguration;
  size: ISizeConfiguration;
}

export interface IBehaviorDocumentEditorHandlesResizeConfiguration {
  modifierKeyAssign: IBehaviorDocumentEditorHandlesResizeModifierKeyAssignConfiguration;
}

export interface IBehaviorDocumentEditorHandlesResizeModifierKeyAssignConfiguration {
  shift: string;
  control: string;
  alt: string;
}

export interface IBehaviorDocumentEditorExtraPageAdditionAtInitializationConfiguration extends IEnableConfiguration {
  isTargetOnly: boolean;
  targets: string[];
}

export interface IBehaviorDocumentEditorChainedObjectUpdationConfiguration {
  overflow: IBehaviorDocumentEditorChainedObjectUpdationOverflowConfiguration;
}

export interface IBehaviorDocumentEditorChainedObjectUpdationOverflowConfiguration {
  max: number;
  level: "warning" | "error";
}

export interface IBehaviorDocumentEditorExternalScriptConfiguration {
  shouldExecuteAsBatch: boolean;
  shouldExecuteAsStackedRequest: boolean;
  executeIntervalMilliSeconds: number;
  executingDialogPollingIntervalMilliSeconds: number;
}

export interface IBehaviorDocumentEditorObjectLocatorConfiguration {
  minSize: ISizeConfiguration;
}

export interface IBehaviorDocumentEditorImageDropperConfiguration extends IEnableConfiguration {
  sizeLimitation: IBehaviorDocumentEditorImageDropperSizeLimitationConfiguration;
}

export interface IBehaviorDocumentEditorImageEditorConfiguration {
  claioSchema: IEnableConfiguration;
  trimming: IEnableConfiguration;
}

export interface IBehaviorDocumentEditorImageDropperSizeLimitationConfiguration extends IEnableConfiguration {
  maxSize: ISizeConfiguration;
}

export interface IBehaviorDocumentEditorEraserConfiguration extends IEnableConfiguration {
  stackMaxSize: number;
  defaultStrokeSize: number;
  strokeSizes: IBehaviorDocumentEditorEraserStrokeSizeItemConfiguration[];
}

export interface IBehaviorDocumentEditorEraserStrokeSizeItemConfiguration {
  label: string;
  size: number;
}

export interface IBehaviorDocumentEditorContentsConfiguration {
  edit: IBehaviorDocumentEditorContentsEditConfiguration;
  clipboard: IEnableConfiguration;
  externalImage: IBehaviorDocumentEditorContentConfiguration;
  claio: IBehaviorDocumentEditorContentsClaioConfiguration;
  ocojo: IBehaviorDocumentEditorContentConfiguration;
  schema: IBehaviorDocumentEditorContentsSchemaConfiguration;
  documentView: IBehaviorDocumentEditorContentsDocumentViewConfiguration;
  fixedPhrase: IBehaviorDocumentEditorContentsFixedPhraseConfiguration;
  aiPhrase: IBehaviorDocumentEditorContentsAiPhraseConfiguration;
  aiTranslation: IBehaviorDocumentEditorContentsAiTranslationConfiguration;
}

export interface IBehaviorDocumentEditorContentsEditConfiguration {
  textStyle: IBehaviorDocumentEditorContentsEditTextStyleConfiguration;
  selector: IBehaviorDocumentEditorContentsEditSelectorConfiguration;
}

export interface IBehaviorDocumentEditorContentsEditTextStyleConfiguration {
  fontFamily: IEnableConfiguration;
}

export interface IBehaviorDocumentEditorContentsEditSelectorConfiguration {
  drawModeSelector: IBehaviorDocumentEditorContentsEditSelectorDrawModeSelectorConfiguration;
  transparentSelector: IEnableConfiguration;
  freeInputSelector: IEnableConfiguration;
}

export interface IBehaviorDocumentEditorContentsEditSelectorDrawModeSelectorConfiguration extends IEnableConfiguration {
  defaultShouldDrawEditStyle: boolean;
}

export interface IBehaviorDocumentEditorContentsClaioConfiguration extends IEnableConfiguration, INameConfiguration, IDisplayCountPerPageConfiguration {
  shouldShowTree: boolean;
  edit: IBehaviorDocumentEditorContentsEditApplicationConfiguration;
  shouldFilterImagesByOrderNo: boolean;
  filters: IBehaviorDocumentEditorContentsClaioFiltersConfiguration;
  preview: IBehaviorDocumentEditorContentsClaioPreviewConfiguration;
  shouldOrderByAscending: boolean;
  imageViewer: IBehaviorDocumentEditorContentsClaioImageViewerConfiguration;
}

export interface IBehaviorDocumentEditorContentsClaioImageViewerConfiguration {
  application: ClaioImageViewerKeys;
}

export type ClaioImageViewerKeys = "claio" | "claioImageView";

export type IBehaviorDocumentEditorContentsEditApplicationConfiguration
  = IEnableConfiguration;

export type IBehaviorDocumentEditorContentConfiguration
  = IEnableConfiguration
  & INameConfiguration
  & IDisplayCountPerPageConfiguration;

export interface IBehaviorDocumentEditorContentsClaioFiltersConfiguration {
  orderNo: IEnableConfiguration;
  shouldPreferTodayImage: boolean;
}

export interface IBehaviorDocumentEditorContentsClaioPreviewConfiguration {
  shouldDisplayActualSize: boolean;
  shouldResizeFitImage: boolean;
  height: number;
}

export interface IBehaviorDocumentEditorContentsSchemaConfiguration extends IEnableConfiguration, INameConfiguration, IDisplayCountPerPageConfiguration {
  shouldExecuteCNoteSchema: boolean;
  shouldExecuteWithDocumentDepartment: boolean;
}

export interface IBehaviorDocumentEditorContentsDocumentViewConfiguration {
  previewWindow: IEnableConfiguration;
  shouldCloseAfterQuotation: boolean;
}

export interface IBehaviorDocumentEditorContentsFixedPhraseConfiguration extends IDefaultSelectedTabConfiguration {
  commonDepartment: IEnableConfiguration;
  defaultFolderName: string;
}

export interface IBehaviorDocumentEditorContentsAiPhraseConfiguration extends IEnableConfiguration, IBehaviorDocumentEditorContentsFixedPhraseConfiguration {
  maxDurationDays: number;
  neverHospitalizedDuration: IBehaviorDocumentEditorContentsAiPhraseNeverHospitalizedDurationConfiguration;
  hospitalization: IBehaviorDocumentEditorContentsAiPhraseHospitalizationConfiguration;
  filters: IBehaviorDocumentEditorContentsAiPhraseFiltersConfiguration;
  recipe: IBehaviorDocumentEditorContentsAiPhraseRecipeConfiguration;
}

export interface IBehaviorDocumentEditorContentsAiPhraseNeverHospitalizedDurationConfiguration {
  shouldFill: boolean;
  days: number;
}

export interface IBehaviorDocumentEditorContentsAiPhraseHospitalizationConfiguration {
  finder: IBehaviorDocumentEditorContentsAiPhraseHospitalizationFinderConfiguration;
}

export interface IBehaviorDocumentEditorContentsAiPhraseHospitalizationFinderConfiguration {
  lastDays: number;
}

export interface IBehaviorDocumentEditorContentsAiPhraseFiltersConfiguration {
  departments: IEnableConfiguration;
  professions: IEnableConfiguration;
}

export interface IBehaviorDocumentEditorContentsAiPhraseRecipeConfiguration {
  name: string;
  selectableRecipes: IBehaviorDocumentEditorContentsAiPhraseRecipeSelectableRecipesConfiguration[];
}

export interface IBehaviorDocumentEditorContentsAiPhraseRecipeSelectableRecipesConfiguration {
  name: string;
  alias: string;
}

export interface IBehaviorDocumentEditorContentsAiTranslationConfiguration extends IEnableConfiguration {
  languages: string[];
}

export interface IBehaviorDocumentEditorPanesConfiguration {
  left: IBehaviorDocumentEditorLeftSidePaneConfiguration;
  right: IBehaviorDocumentEditorAutomaticSwitchPaneConfiguration;
}

export interface IBehaviorDocumentEditorLeftSidePaneConfiguration extends IDefaultSelectedTabConfiguration {
  maxWidth: number;
}

export interface IBehaviorDocumentEditorAutomaticSwitchPaneConfiguration extends IDefaultSelectedTabConfiguration {
  automaticSwitchingWidth: number;
}

export interface IBehaviorDocumentEditorPageNavigatorConfiguration {
  visiblePageCount: number;
  expandablePageCount: number;
  pageCountToExpand: number;
  isRightSide: boolean;
  focusIndicator: IBehaviorDocumentEditorPageNavigatorFocusIndicatorConfiguration;
  expander: IExpanderAreaConfiguration;
  expandedWidth: number;
}

export interface IBehaviorDocumentEditorPageNavigatorFocusIndicatorConfiguration {
  borderWidth: number;
}

export interface IExpanderAreaConfiguration {
  areaWidth: number;
  fontSize: number;
}

export interface IBehaviorDocumentEditorMischievousObjectsConfiguration {
  createDate: IBehaviorDocumentEditorMischievousCreateDateConfiguration;
  hospitalization: IBehaviorDocumentEditorMischievousHospitalizationConfiguration;
  disease: IBehaviorDocumentEditorMischievousArrangedObjectConfiguration;
  externalData: IBehaviorDocumentEditorMischievousExternalDataConfiguration;
  doctor: IBehaviorDocumentEditorMischievousDoctorConfiguration;
}

export interface IBehaviorDocumentEditorMischievousDoctorConfiguration {
  fillAutomatically: IDocumentTypeKindSpecifiableConfiguration;
}

export interface IBehaviorDocumentEditorMischievousExternalDataConfiguration {
  shouldExeucuteWhenHisInformationManualUpdate: boolean;
}

export interface IBehaviorDocumentEditorMischievousCreateDateConfiguration {
  shouldUpdateAndRollbackExceptFreeInputSelectedObject: boolean;
  updateAndRollback: IDocumentTypeKindSpecifiableConfiguration;
}

export interface IDocumentTypeKindSpecifiableConfiguration {
  direct: boolean;
  workflow: boolean;
}

export interface IBehaviorDocumentEditorMischievousHospitalizationConfiguration extends IBehaviorDocumentEditorMischievousArrangedObjectConfiguration {
  shouldSelectHospitalizationInitialItemHospitalizedOnly: boolean;
}

export interface IBehaviorDocumentEditorMischievousArrangedObjectConfiguration {
  shouldApplyBySubName: boolean;
  shouldValidateSubNameFormat: boolean;
  targetSubNameFormat: string;
}

export interface IBehaviorDocumentEditorMenusConfiguration {
  registerAsTemporaryAndPrintWithWatermark: IRegisterAsTemporaryAndPrintWithWatermarkConfiguration;
  registerAsTemporaryAndPrint: INameConfiguration;
  registerAsTemporary: INameConfiguration;
  registerAndPrint: INameConfiguration;
  registerAndPrintWithDialog: IRegisterAndPrintWithDialogConfiguration;
  register: INameConfiguration;
  printWithoutRegistration: INameConfiguration;
}

export type IRegisterAsTemporaryAndPrintWithWatermarkConfiguration
  = INameConfiguration
  & IEnableConfiguration;

export type IRegisterAndPrintWithDialogConfiguration
  = INameConfiguration
  & IEnableConfiguration;

export interface IBehaviorDocumentEditorNotificationsConfiguration {
  registerAsTemporary: IMessageConfiguration;
}

export interface IBehaviorDocumentEditorDesignatedDoctorNumberConfiguration extends IEnableConfiguration {
  shouldSetWhiteSpaceIfEmpty: boolean;
}

export interface IBehaviorDocumentEditorRegistererConfiguration {
  instantCloser: IBehaviorDocumentEditorRegistererInstantCloserConfiguration;
  allPagesEditValidator: IEnableConfiguration;
  shouldPrintSpecifiedSectionAtFirstRegistration: IDocumentTypeKindSpecifiableConfiguration;
  postRegistration: IBehaviorDocumentEditorRegistererPostRegistrationConfiguration;
}

export interface IBehaviorDocumentEditorRegistererPostRegistrationConfiguration {
  applications: IBehaviorDocumentEditorRegistererPostRegistrationApplicationConfiguration[];
}

export interface IBehaviorDocumentEditorRegistererPostRegistrationApplicationConfiguration extends IEnableConfiguration {
  executeCondition: IBehaviorDocumentEditorRegistererPostRegistrationApplicationExecuteConditionConfiguration;
  modulePath: string;
  parameter: string;
}

export interface IBehaviorDocumentEditorRegistererPostRegistrationApplicationExecuteConditionConfiguration {
  registration: ExecuteConditionRegistrationKindKeys;
  printing: ExecuteConditionPrintingKindKeys;
}

export type ExecuteConditionRegistrationKindKeys = "any" | "register" | "registerAsTemporary";
export type ExecuteConditionPrintingKindKeys = "any" | "withPrinting" | "withoutPrinting";

export interface IBehaviorDocumentEditorRegistererInstantCloserConfiguration extends IEnableConfiguration {
  waitTimeAsMsec: number;
  notification: IBehaviorDocumentEditorRegistererInstantCloserNotificationConfiguration;
}

export interface IBehaviorDocumentEditorRegistererInstantCloserNotificationConfiguration extends IEnableConfiguration, IMessageConfiguration {
  delayAsMsec: number;
}

export interface IBehaviorDocumentEditorDeleterConfiguration {
  postDeletion: IBehaviorDocumentEditorDeleterPostDeletionConfiguration;
}

export interface IBehaviorDocumentEditorDeleterPostDeletionConfiguration {
  applications: IBehaviorDocumentEditorDeleterPostDeletionApplicationConfiguration[];
}

export interface IBehaviorDocumentEditorDeleterPostDeletionApplicationConfiguration extends IEnableConfiguration {
  modulePath: string;
  parameter: string;
}

export interface IBehaviorDocumentEditorValidatorsConfiguration {
  textLength: IBehaviorDocumentEditorValidatorConfiguration;
  urls: string[];
  mark: IBehaviorDocumentEditorValidatorsMarkConfiguration;
}

export interface IBehaviorDocumentEditorValidatorsMarkConfiguration {
  shouldShowEmptyAlertMarkOnEditStart: boolean;
}

export interface IBehaviorDocumentEditorValidatorConfiguration {
  isError: boolean;
}

export interface IBehaviorDocumentEditorInjectorConfiguration {
  urls: string[];
}

export interface IBehaviorDocumentEditorConflictConfiguration {
  editConfirmation: IEnableConfiguration;
  editTokenManagement: IEnableConfiguration;
  createConfirmation: IEnableConfiguration;
  createTokenManagement: IEnableConfiguration;
  alert: IBehaviorDocumentEditorConflictAlertConfiguration;
}

export interface IBehaviorDocumentEditorConflictAlertConfiguration {
  message: string;
  color: string;
  isBold: boolean;
}

export interface IBehaviorDocumentEditorObjectsConfiguration {
  shouldHideOutsidePage: boolean;
  shouldTransformSideLocatedObjectsByRelayout: boolean;
  richTextBox: IRichTextObjectBehaviorConfiguration;
  rangeOfMotion: IRangeOfMotionObjectBehaviorConfiguration;
  sign: ISignObjectBehaviorConfiguration;
}

export interface ISignObjectBehaviorConfiguration {
  signTablet: IEnableConfiguration;
}

export interface IRichTextObjectBehaviorConfiguration {
  tabReplacementSpacesCount: number;
  maxTextLength: number;
  adjustedHeightMagnification: number;
  adjustedHeightMargin: number;
}

export interface IRangeOfMotionObjectBehaviorConfiguration {
  orderOfObjects: string;
}

export interface IBehaviorDocumentEditorNewObjectsConfiguration {
  shouldShowInvisibleGroup: boolean;
  "NewArrowLine": IBehaviorDocumentEditorNewObjectConfiguration;
  "NewBoxLine": IBehaviorDocumentEditorNewStampableObjectConfiguration;
  "NewCircle": IBehaviorDocumentEditorNewStampableObjectConfiguration;
  "NewCross": IBehaviorDocumentEditorNewStampableObjectConfiguration;
  "NewImage": IBehaviorDocumentEditorNewObjectConfiguration;
  "NewLine": IBehaviorDocumentEditorNewObjectConfiguration;
  "NewNewPage": IBehaviorDocumentEditorNewObjectConfiguration;
  "NewPolyline": IBehaviorDocumentEditorNewObjectConfiguration;
  "NewTag": IBehaviorDocumentEditorNewObjectConfiguration;
  "NewText": IBehaviorDocumentEditorNewObjectConfiguration;
  "NewTriangle": IBehaviorDocumentEditorNewStampableObjectConfiguration;
  "NewInvisibleArrowLine": IBehaviorDocumentEditorNewObjectConfiguration;
  "NewInvisibleBoxLine": IBehaviorDocumentEditorNewStampableObjectConfiguration;
  "NewInvisibleCircle": IBehaviorDocumentEditorNewStampableObjectConfiguration;
  "NewInvisibleCross": IBehaviorDocumentEditorNewStampableObjectConfiguration;
  "NewInvisibleLine": IBehaviorDocumentEditorNewObjectConfiguration;
  "NewInvisiblePolyline": IBehaviorDocumentEditorNewObjectConfiguration;
  "NewInvisibleTriangle": IBehaviorDocumentEditorNewStampableObjectConfiguration;
}

export interface IBehaviorDocumentEditorNewObjectConfiguration {
  source: any;
}

export type IBehaviorDocumentEditorNewStampableObjectConfiguration
  = IBehaviorDocumentEditorNewObjectConfiguration
  & INewObjectConfiguration;

export interface IBehaviorDocumentEditorSignConfiguration {
  newObjects: IBehaviorDocumentEditorNewSignObjectsConfiguration;
}

export interface IBehaviorDocumentEditorNewSignObjectsConfiguration {
  "NewPen": IBehaviorDocumentEditorNewObjectConfiguration;
}

export interface IBehaviorDocumentEditorPreviewMenuConfiguration {
  printing: IEnableConfiguration;
  shouldShowPrintPreview: boolean;
}

export interface IBehaviorDocumentEditorDocumentAttributesConfiguration {
  createdDate: IEnableConfiguration;
  department: IBehaviorDocumentEditorDocumentAttributesDepartmentConfiguration;
  orderUser: IBehaviorDocumentEditorDocumentAttributesExtraUserConfiguration;
  attendingUser: IBehaviorDocumentEditorDocumentAttributesExtraUserConfiguration;
  scale: IBehaviorDocumentEditorDocumentAttributesScaleConfiguration;
}

export interface IBehaviorDocumentEditorDocumentAttributesExtraUserConfiguration {
  shouldUpdateOnEditStart: boolean;
}

export interface IBehaviorDocumentEditorDocumentAttributesDepartmentConfiguration {
  shouldUpdateDepartmentHisObjectsWhenChanged: boolean;
}

export interface IBehaviorDocumentEditorDocumentAttributesScaleConfiguration {
  defaultScaleAsPercentage: number;
}

export interface IBehaviorDocumentEditorExternalTemplatesConfiguration {
  shouldSetCopiedIdWhenTemplateCopied: boolean;
}

export interface IBehaviorDocumentEditorQuotationConfiguration {
  isOtherPatientDocumentQuotable: boolean;
  shouldApplyValueToEmptyObjectOnly: boolean;
  shouldCopyAllAdditionalItems: IQuotationModeSpecifiableConfiguration;
  shouldCopyExtraSections: IQuotationModeSpecifiableConfiguration;
  formatFilter: IEnableConfiguration;
}

export interface IQuotationModeSpecifiableConfiguration {
  byObjectName: boolean;
  byObjectId: boolean;
}

export interface IBehaviorDocumentEditorPreviewConfiguration {
  shouldPrintWatermarkForcibly: boolean;
}

export interface IBehaviorDocumentEditorMultipleConfiguration {
  isMultiplePatientDocumentEditable: boolean;
}

export interface IBehaviorDocumentEditorDepartmentGroupConfiguration {
  shouldIgnoreDepartmentGroupFilter: boolean;
}

export interface IBehaviorDocumentEditorTemporaryNoteConfiguration {
  shouldShowInputDialogBeforeRegisterAsTemporary: boolean;
  shouldShowTemporaryNoteOnEditStart: boolean;
}

export interface IBehaviorDocumentViewerConfiguration {
  isMajorActionInstant: boolean;
  menu: IBehaviorDocumentViewerMenuConfiguration;
  printing: IBehaviorDocumentPrintingConfiguration;
  externalMenus: IExternalMenuItemConfiguration[];
  pdfRendering: IBehaviorDocumentViewerPdfRenderingConfiguration;
}

export interface IBehaviorDocumentViewerPdfRenderingConfiguration {
  shouldRenderUnmanagedDocumentByPlugin: boolean; // MEDI-Papyrusが出力するPDFの一部で一部テキストがPDF.jsで表示されない問題あり.MEDI-Papyrus移行案件はtrueに設定要.
}

export interface IBehaviorDocumentViewerMenuConfiguration extends IEnableConfiguration {
  quote: IEnableConfiguration;
  note: IEnableConfiguration;
}

export interface IBehaviorDocumentPrintingConfiguration {
  shouldPrintDefaultCopies: boolean;
}

export interface IBehaviorDocumentListConfiguration {
  infiniteLoader: IBehaviorDocumentListInfiniteLoaderConfiguration;
  menu: IBehaviorDocumentListMenusConfiguration;
  sort: IBehaviorDocumentListSortsConfiguration;
  selector: IBehaviorDocumentListSelectorConfiguration;
  finder: IBehaviorDocumentListFinderConfiguration;
  patientSpecified: IBehaviorDocumentListPatientSpecifiedConfiguration;
  presetFilters: IBehaviorDocumentListPresetFiltersConfiguration;
  csv: IEnableConfiguration;
  printing: IBehaviorDocumentPrintingConfiguration;
}

export interface IBehaviorDocumentListPresetFiltersConfiguration {
  [key: string]: IDocumentFilterConfiguration;
}

export interface IBehaviorDocumentListInfiniteLoaderConfiguration {
  rowCount: number;
}

export interface IBehaviorDocumentListMenusConfiguration {
  create: IEnableConfiguration;
  quote: IEnableConfiguration;
  quoteAutomatically: IEnableConfiguration;
  copy: IEnableConfiguration;
  externalMenus: IExternalMenuItemConfiguration[];
  patientExternalMenus: IExternalMenuItemConfiguration[];
  previewLikeEditing: IEnableConfiguration;
  documentPublishedHistory: IDocumentPublishedHistoryConfiguration;
}

export interface IExternalMenuItemConfiguration extends IEnableConfiguration {
  title: string;
  description: string;
  iconClass: string;
  url: string;
  parameters: { [key: string]: string; };
  modulePath: string;
  iconImageSource: string;
  disableIconImageSource: string;
  ignoreAssistant?: boolean; // Assistantを使わない.(url指定のみ可能.)
}

export interface IDocumentPublishedHistoryConfiguration {
  shouldShowPrinterName: boolean;
}

export interface IBehaviorDocumentListSortsConfiguration {
  default: IBehaviorDocumentListSortConfiguration;
}

export interface IBehaviorDocumentListSortConfiguration extends IEnableConfiguration {
  columnKey: string;
  isDescending: boolean;
}

export interface IBehaviorDocumentListFinderConfiguration {
  duration: IBehaviorDocumentListFinderDurationsConfiguration;
  conditionIndication: IBehaviorDocumentListFinderConditionIndicationConfiguration;
  collapse: IBehaviorDocumentListFinderCollapseConfiguration;
  notification: IBehaviorDocumentListFinderNotificationConfiguration;
}

export interface IBehaviorDocumentListFinderNotificationConfiguration {
  limitExceed: IBehaviorDocumentListFinderNotificationItemConfiguration;
}

export interface IBehaviorDocumentListFinderNotificationItemConfiguration extends IEnableConfiguration {
  message: string;
}

export interface IBehaviorDocumentListFinderDurationsConfiguration {
  default: IBehaviorDocumentListFinderDurationConfiguration;
}

export interface IBehaviorDocumentListFinderDurationConfiguration {
  isDocument: boolean;
}

export interface IBehaviorDocumentListFinderConditionIndicationConfiguration {
  format: IBehaviorDocumentListFinderConditionIndicationFormatConfiguration;
}

export interface IBehaviorDocumentListFinderConditionIndicationFormatConfiguration {
  max: number;
}

export interface IBehaviorDocumentListFinderCollapseConfiguration {
  shouldShrinkAutomatically: boolean;
}

export interface IBehaviorDocumentListPatientSpecifiedConfiguration {
  finder: IBehaviorDocumentListPatientSpecifiedFinderConfiguration;
}

export interface IBehaviorDocumentListPatientSpecifiedFinderConfiguration {
  duration: IBehaviorDocumentListFinderDurationsConfiguration;
}

export interface IBehaviorDocumentRegisterNewDocumentsConfiguration {
  his: IBehaviorDocumentRegisterNewDocumentsHisConfiguration;
}

export interface IBehaviorDocumentRegisterNewDocumentsHisConfiguration {
  emptyKeys: string[];
}

export interface IBehaviorDocumentEntityConfiguration {
  date: IBehaviorDocumentEntityDateConfiguration;
  time: IBehaviorDocumentEntityTimeConfiguration;
}

export interface IBehaviorDocumentEntityDateConfiguration {
  formats: IDateFormatConfiguration[];
}

export interface IBehaviorDocumentEntityTimeConfiguration {
  formats: ITimeFormatConfiguration[];
  formatsIncludeSecond: ITimeFormatConfiguration[];
}

export interface IBehaviorDocumentPreviewWindowConfiguration {
  parentWatchIntervalMilliSeconds: number;
}

export interface IBehaviorDocumentProcessorConfiguration {
  executeIntervalMilliSeconds: number;
  errorCloseIntervalMilliSeconds: number;
}

export interface IBehaviorFormatConfiguration {
  formatSet: IBehaviorFormatSetConfiguration;
  selector: IBehaviorFormatSelectorConfiguration;
  multiSelector: IMultiSelectorConfiguration;
  referenceFile: IBehaviorFormatReferenceFileConfiguration;
  favorite: IBehaviorFormatFavoriteConfiguration;
  option: IBehaviorFormatOptionConfiguration;
  list: IBehaviorFormatListConfiguration;
  editor: IBehaviorFormatEditorConfiguration;
}

export interface IBehaviorFormatEditorConfiguration {
  sharing: IEnableConfiguration;
}

export interface IBehaviorFormatSelectorConfiguration extends IDefaultSelectedTabConfiguration {
  tab: IBehaviorFormatSelectorTabConfiguration;
  shouldExpandTreeAutomatically: boolean;
  collapse: IBehaviorFormatSelectorCollapseConfiguration;
  shouldShowDirectoryPath: boolean;
}

export interface IBehaviorFormatSelectorTabConfiguration {
  all: IEnableConfiguration;
  commonDepartment: IEnableConfiguration;
  department: IBehaviorDepartmentFormatSelectorConfiguration;
  user: IEnableConfiguration;
}

export interface IBehaviorDepartmentFormatSelectorConfiguration extends IEnableConfiguration {
  isDepartmentSelectable: boolean;
}

export interface IBehaviorFormatSelectorCollapseConfiguration {
  shouldShrinkAutomatically: boolean;
}

export interface IBehaviorFormatSetConfiguration extends IEnableConfiguration {
  shouldOpenWindowsWithUrlScheme: boolean;
  tab: IBehaviorFormatSetSelectorTabConfiguration;
}

export interface IBehaviorFormatSetSelectorTabConfiguration {
  commonDepartment: IEnableConfiguration;
  department: IBehaviorFormatSetSelectorTabDepartmentConfiguration;
  user: IEnableConfiguration;
}

export interface IBehaviorFormatSetSelectorTabDepartmentConfiguration extends IEnableConfiguration {
  isDepartmentSelectable: boolean;
}

export interface IBehaviorFormatReferenceFileConfiguration {
  shouldShowPdfByClientViewer: boolean;
  forceEnableOpenTypeFontFace: boolean;
}

export interface IBehaviorFormatFavoriteConfiguration {
  defaultFolderName: string;
}

export interface IBehaviorFormatOptionConfiguration {
  masterCodePrefixes: IBehaviorFormatMasterCodePrefixConfiguration[];
}

export interface IBehaviorFormatListConfiguration {
  menu: IBehaviorFormatListMenusConfiguration;
}

export interface IBehaviorFormatListMenusConfiguration {
  documentList: IEnableConfiguration;
  externalMenus: IExternalMenuItemConfiguration[];
}

export interface IBehaviorFormatMasterCodePrefixConfiguration {
  prefix: string;
}

export interface IBehaviorPatientConfiguration {
  feature: IEnableConfiguration;
  fixed: IBehaviorFixedConfiguration;
  id: IBehaviorPatientIdConfiguration;
  finder: IBehaviorPatientFinderConfiguration;
  otherId: IEnableConfiguration;
}

export interface IBehaviorPatientIdConfiguration {
  isNumberOnly: boolean;
}

export interface IBehaviorPatientFinderConfiguration {
  shouldConfirmFoundPatient: boolean;
  name: IBehaviorPatientFinderNameConfiguration;
}

export interface IBehaviorPatientFinderNameConfiguration {
  isEnable: boolean;
}

export interface IBehaviorDepartmentGroupConfiguration {
  feature: IEnableConfiguration;
  scope: IEnableConfiguration;
}

export interface IBehaviorDepartmentConfiguration {
  feature: IEnableConfiguration;
  fixed: IBehaviorFixedConfiguration;
  multiSelector: IMultiSelectorConfiguration;
}

export interface IBehaviorProfessionConfiguration {
  feature: IEnableConfiguration;
}

export interface IBehaviorFixedConfiguration extends IEnableConfiguration {
  code: string;
}

export interface IBehaviorLocalhostConfiguration extends IEnableConfiguration {
  schemeUrlPrefix: string;
  httpUrlPrefix: string;
  application: IEnableConfiguration;
  internalScript: IBehaviorLocalhostInternalScriptsConfiguration;
  externalScript: IBehaviorLocalhostExternalScriptConfiguration;
  printer: IEnableConfiguration;
  clipboard: IBehaviorLocalhostClipboardConfiguration;
  clippedImageRegisterer: IBehaviorLocalhostClippedImageRegistererConfiguration;
  window: IBehaviorLocalhostWindowConfiguration;
}

export interface IBehaviorLocalhostInternalScriptsConfiguration extends IEnableConfiguration {
  scripts: IBehaviorLocalhostInternalScriptItemsConfiguration;
}

export interface IBehaviorLocalhostInternalScriptItemsConfiguration {
  convertReplacer: IBehaviorLocalhostInternalScriptItemConfiguration;
  imageDateTimeGetter: IBehaviorLocalhostInternalScriptItemConfiguration;
  valueConverter: IBehaviorLocalhostInternalScriptItemConfiguration;
  externalSystemValueGetter: IBehaviorLocalhostInternalScriptItemConfiguration;
  professionGetter: IBehaviorLocalhostInternalScriptItemConfiguration;
  generalReplacer: IBehaviorLocalhostInternalScriptItemConfiguration;
  currentDateTimeGetter: IBehaviorLocalhostInternalScriptItemConfiguration;
}

export interface IBehaviorLocalhostInternalScriptItemConfiguration extends IEnableConfiguration {
  pathExpression: string;
}

export interface IBehaviorLocalhostExternalScriptConfiguration {
  responseWaiting: IResponseWaitingConfiguration;
  webApplication: IBehaviorLocalhostExternalWebApplicationConfiguration;
}

export interface IBehaviorLocalhostExternalWebApplicationConfiguration {
  closeWaitMilliSeconds: number;
  hisDataPicker: IBehaviorLocalhostExternalWebApplicationItemConfiguration;
  introductionSelector: IBehaviorLocalhostExternalWebApplicationItemConfiguration;
}

export interface IBehaviorLocalhostExternalWebApplicationItemConfiguration extends IEnableConfiguration {
  pathExpression: string;
}

export interface IBehaviorLocalhostClipboardConfiguration extends IEnableConfiguration {
  serviceIntervalAsMsec: number;
}

export interface IBehaviorLocalhostClippedImageRegistererConfiguration extends IEnableConfiguration {
  responseWaiting: IResponseWaitingConfiguration;
}

export interface IBehaviorLocalhostWindowConfiguration {
  opener: IBehaviorLocalhostWindowOpenerConfiguration;
}

export interface IBehaviorLocalhostWindowOpenerConfiguration extends IEnableConfiguration {
  restrictions: IBehaviorLocalhostWindowOpenerRestrictionsConfiguration;
}

export interface IBehaviorLocalhostWindowOpenerRestrictionsConfiguration {
  path: IBehaviorLocalhostWindowOpenerRestrictionsPathConfiguration;
  browser: IEnableConfiguration;
}

export interface IBehaviorLocalhostWindowOpenerRestrictionsPathConfiguration extends IEnableConfiguration {
  paths: IPathRouteConfiguration [];
}

export interface IBehaviorUserConfiguration {
  finder: IBehaviorUserFinderConfiguration;
  multiSelector: IMultiSelectorConfiguration;
}

export interface IBehaviorUserFinderConfiguration {
  doctorProfessionCodes: string[];
  shouldShowProjectTeamSelector: boolean;
  shouldShowDesignatedDoctorSelector: boolean;
  shouldShowBelongedAllDepartmentsSelector: boolean;
  shouldFilterBelongedAllDepartmentsSelector: boolean;
  shouldFilterDepartmentUsersByMainDepartment: boolean;
  shouldShowPhoneNumber: boolean;
}

export interface IBehaviorReceptionConfiguration extends IEnableConfiguration {
  editor: IBehaviorReceptionEditorConfiguration;
  list: IBehaviorReceptionListConfiguration;
}

export interface IBehaviorReceptionEditorConfiguration {
  shouldConfirmToLeavePage: boolean;
  shouldRegisterNewWorkflowDocumentsWhenNewReceptionRegistered: boolean;
  shouldRegisterNewRequestSheetWhenNewReceptionRegistered: boolean;
  confirmMessageToLeavePage: string;
  confirmMessageToCloseWindow: string;
  closeWindowConfirmation: ICloseWindowConfirmationConfiguration;
  conflict: IBehaviorReceptionEditorConflictConfiguration;
}

export interface IBehaviorReceptionEditorConflictConfiguration {
  createConfirmation: IEnableConfiguration;
  createTokenManagement: IEnableConfiguration;
}

export interface IBehaviorReceptionListConfiguration {
  finder: IBehaviorReceptionListFinderConfiguration;
  panes: IBehaviorReceptionListPanesConfiguration;
  selector: IDefaultSelectedTabConfiguration;
  tabs: IBehaviorReceptionListTabsConfiguration;
  detailDialog: IBehaviorReceptionListDetailDialogConfiguration;
  sort: IBehaviorReceptionListSortConfiguration;
  filter: IBehaviorReceptionListFilterConfiguration;
  menu: IBehaviorReceptionListMenuConfiguration;
}

export interface IBehaviorReceptionListFinderConfiguration {
  patient: IBehaviorReceptionListFinderPatientConfiguration;
}

export interface IBehaviorReceptionListFinderPatientConfiguration {
  history: IBehaviorReceptionListFinderPatientHistoryConfiguration;
}

export interface IBehaviorReceptionListFinderPatientHistoryConfiguration extends IEnableConfiguration {
  maxCount: number;
}

export interface IBehaviorReceptionListPanesConfiguration {
  automaticSwitchingWidth: number;
}

export interface IBehaviorReceptionListTabsConfiguration {
  departmentTodo: IBehaviorReceptionListTabsDepartmentTodoConfiguration;
}

export interface IBehaviorReceptionListDetailDialogConfiguration {
  panes: IBehaviorReceptionListDetailDialogPanesConfiguration;
}

export interface IBehaviorReceptionListDetailDialogPanesConfiguration {
  automaticSwitchingWidth: number;
}

export interface IBehaviorReceptionListSortConfiguration {
  default: IBehaviorReceptionListSortDefaultConfiguration;
}

export interface IBehaviorReceptionListFilterConfiguration extends IEnableConfiguration {
  filters: IBehaviorReceptionListFilterOptionConfiguration[];
}

export interface IBehaviorReceptionListFilterOptionConfiguration {
  label: string;
  validation: string;
  target?: "workflow" | "todo";
}

export interface IBehaviorReceptionListMenuConfiguration {
  adminExternalMenus: IExternalMenuItemConfiguration[];
}

export interface IBehaviorReceptionListSortDefaultConfiguration {
  card: IBehaviorReceptionListSortDefaultStyleConfiguration;
  list: IBehaviorReceptionListSortDefaultStyleConfiguration;
}

export interface IBehaviorReceptionListSortDefaultStyleConfiguration extends IEnableConfiguration {
  columnKey: string;
  isDescending: boolean;
}

export interface IBehaviorReceptionListTabsDepartmentTodoConfiguration extends IEnableConfiguration {}

export interface IBehaviorAuthenticationConfiguration {
  logout: IEnableConfiguration;
  login: IBehaviorAuthenticationLoginConfiguration;
}

export interface IBehaviorAuthenticationLoginConfiguration {
  shouldSelectDepartment: boolean;
  shouldSelectDepartmentAutomatically: boolean;
  shouldSkipDepartmentAutoSelectionIfDepartmentsIsEmpty: boolean;
  shouldSelectDepartmentGroupByLoginDepartmentAutomatically: boolean;
}

export interface IBehaviorCollaborationsConfiguration {
  claio: IBehaviorCollaborationConfiguration;
  externalImage: IBehaviorCollaborationConfiguration;
  schema: IBehaviorCollaborationConfiguration;
  ocojo: IBehaviorCollaborationConfiguration;
  scan: IBehaviorCollaborationScanConfiguration;
}

export interface IBehaviorCollaborationConfiguration {
  imageName: string;
}

export interface IBehaviorCollaborationScanConfiguration {
  shouldVerifyBeforeEdit: boolean;
  shouldVerifyBeforeDelete: boolean;
  shouldVerifyOnEditStart: boolean;
  scannedDocumentEditConfirmMessage: string;
}

export interface IBehaviorHeaderConfiguration {
  message: IBehaviorHeaderMessageConfiguration;
}

export interface IBehaviorFixedPhraseConfiguration {
  shouldExpandTreeAutomatically: boolean;
}

export interface IBehaviorSettingConfiguration extends IEnableConfiguration {
  shouldShowTreeNodeKey: boolean;
}

export interface IBehaviorWizardConfiguration {
  editor: IBehaviorWizardEditorConfiguration;
}

export interface IBehaviorWizardEditorConfiguration {
  shouldShowNotImplemented: boolean;
}

export interface IBehaviorHeaderMessageConfiguration extends IEnableConfiguration {
  displayText: string;
  styleProperties: any;
}

export interface IStyleConfiguration {
  theme: string;
  panes: IStylePanesConfiguration;
  document: IStyleDocumentConfiguration;
  format: IStyleFormatConfiguration;
  alertIndication: IStyleIndicationConfiguration;
  noticeIndication: IStyleIndicationConfiguration;
  header: IStyleHeaderConfiguration;
}

export interface IStylePanesConfiguration {
  rightSide: IStylePanesSideConfiguration;
}

export interface IStylePanesSideConfiguration {
  shouldMainContentsPlaceBottom: boolean;
}

export interface IStyleDocumentConfiguration {
  editor: IStyleDocumentEditorConfiguration;
  list: IStyleDocumentListConfiguration;
}

export interface IStyleDocumentEditorConfiguration {
  objects: IStyleDocumentEditorObjectsConfiguration;
  focusIndicator: IStyleDocumentEditorFocusIndicatorConfiguration;
  colorPallets: string[];
  focusedObject: IStyleDocumentEditorFocusedObjectConfiguration;
}

export interface IStyleDocumentEditorObjectsConfiguration {
  barcode: IColorFixedObjectStyleConfiguration;
  calculate: ICalculateObjectStyleConfiguration;
  checkBox: ICheckBoxObjectStyleConfiguration;
  circleSelect: IColorFixedObjectStyleConfiguration;
  comboBox: IComboBoxObjectStyleConfiguration;
  date: IDateObjectStyleConfiguration;
  externalData: IExternalDataObjectStyleConfiguration;
  externalProcess: IColorFixedObjectStyleConfiguration;
  image: IImageObjectStyleConfiguration;
  sign: ISignObjectStyleConfiguration;
  movableImage: IMovableImageObjectStyleConfiguration;
  movableTextBox: IMovableTextObjectStyleConfiguration;
  roll: IRollObjectStyleConfiguration;
  textBox: ITextObjectStyleConfiguration;
  rangeOfMotionTextBox: IColorFixedObjectStyleConfiguration;
  joinText: IJoinTextObjectStyleConfiguration;
  richTextBox: IRichTextObjectStyleConfiguration;
  stamp: IColorFixedObjectStyleConfiguration;
}

export interface IStyleDocumentEditorNewObjectConfiguration {
  fontSize: number;
}

export interface IStyleDocumentEditorFocusIndicatorConfiguration {
  borderWidth: number;
}

export interface IStyleDocumentEditorFocusedObjectConfiguration {
  shouldDrawForeground: boolean;
}

export interface IStyleDocumentListConfiguration {
  selector: IStyleDocumentListSelectorConfiguration;
}

export interface IStyleDocumentListSelectorConfiguration {
  style: IStyleDocumentListSelectorStyleConfiguration;
}

export interface IStyleDocumentListSelectorStyleConfiguration {
  unpublished: IColorConfiguration;
  row: IStyleDocumentListSelectorStyleRowConfiguration;
  list: IStyleDocumentListSelectorStyleListConfiguration;
}

export interface IStyleDocumentListSelectorStyleRowConfiguration {
  deleted: IBackgroundColorConfiguration;
  temporary: IBackgroundColorConfiguration;
}

export interface IStyleDocumentListSelectorStyleListConfiguration {
  columns: { [key: string]: IStyleDocumentListSelectorStyleListColumnConfiguration };
}

export interface IStyleDocumentListSelectorStyleListColumnConfiguration {
  padding?: IStyleDocumentListSelectorStyleListColumnPaddingConfiguration;
  width?: number;
  shouldWrap?: boolean;
  fontSize?: number;
}

export interface IStyleDocumentListSelectorStyleListColumnPaddingConfiguration {
  topAndBottom: number;
  leftAndRight: number;
}

export interface IStyleFormatConfiguration {
  listViewSelector: IStyleFormatListViewSelectorConfiguration;
}

export interface IStyleIndicationConfiguration {
  color: string;
  backgroundColor: string;
}

export interface IStyleHeaderConfiguration {
  windowName: IStyleHeaderWindowNameConfiguration;
}

export interface IStyleHeaderWindowNameConfiguration {
  windows: IStyleHeaderWindowNameWindowsConfiguration[];
}

export interface IStyleHeaderWindowNameWindowsConfiguration {
  expression: string;
  style: IStyleIndicationConfiguration;
}

export interface IStyleFormatListViewSelectorConfiguration {
  selector: IStyleFormatListViewSelectorSelectorConfiguration;
}

export interface IStyleFormatListViewSelectorSelectorConfiguration {
  width: number;
}

export interface IRoutingConfiguration {
  unrestorableRouteExpressions: string[];
}

export interface ISystemConfiguration {
  window: ISystemWindowConfiguration;
  notification: ISystemNotificationConfiguration;
  date: ISystemDateConfiguration;
  dateSelector: ISystemDateSelectorConfiguration;
  urlScheme: ISystemUrlSchemeConfiguration;
  pdfRendering: ISystemPdfRenderingConfiguration;
  help: IEnableConfiguration;
}

export interface ISystemWindowConfiguration {
  opener: ISystemWindowOpenerConfiguration;
  restorer: ISystemWindowRestorerConfiguration;
  initializer: ISystemWindowInitializerConfiguration;
  manager: ISystemWindowManagerConfiguration;
}

export interface ISystemWindowOpenerConfiguration {
  features: string;
  locatorBasedOnFullScreen: ISystemWindowOpenerLocatorBasedOnFullScreenConfiguration;
  offsets: ILocationConfiguration;
}

export interface ISystemWindowOpenerLocatorBasedOnFullScreenConfiguration extends IEnableConfiguration {
  rates: ILocationConfiguration;
}

export interface ISystemWindowRestorerConfiguration extends IEnableConfiguration {
  shouldStoreDb: boolean;
  label: string;
  storedKeys: ISystemWindowRestorerStoredKeyConfiguration[];
  restorableMinimumSize: ISizeConfiguration;
  additonalRestoreDelayMilliSeconds: number;
}

export interface ISystemWindowRestorerStoredKeyConfiguration {
  route: string;
  key: string;
}

export interface ISystemWindowInitializerConfiguration extends IEnableConfiguration {
  minimumSize: ISizeConfiguration;
  shouldResetLocationWhenResize: boolean;
}

export interface ISystemWindowManagerConfiguration {
  shouldIgnoreQuitWhenLaunchedByHasValueAndMessageValueIsEmpty: boolean;
}

export interface ISystemNotificationConfiguration {
  position: string;
}

export interface ISystemDateConfiguration {
  shouldOverwriteEras: boolean;
  japaneseEras: IEraConfiguration[];
  years: ISystemDateYearsConfiguration;
}

export interface ISystemDateSelectorConfiguration {
  customButtons: ISystemDateSelectorCustomButtonConfiguration[];
}

export interface ISystemDateSelectorCustomButtonConfiguration {
  type: DateSelectorCustomButtonType;
  label: string;
  parameters: ISystemDateSelectorCustomButtonParametersConfiguration;
}

export interface ISystemDateSelectorCustomButtonParametersConfiguration {
  year?: number;
  month?: number;
  day?: number;
}

export interface ISystemDateYearsConfiguration {
  count: ISystemDateYearsCountConfiguration;
}

export interface ISystemDateYearsCountConfiguration {
  future: number;
  past: number;
}

export interface ISystemUrlSchemeConfiguration {
  beforeUnloadEventSetInterval: number;
}

export interface ISystemPdfRenderingConfiguration {
  shouldRenderSelf: boolean;
  switchPdfViewer: boolean;
  accessorOption: ISystemPdfRenderingAccessorOptionConfiguration;
  viewType: PdfViewType;
}

export interface ISystemPdfRenderingAccessorOptionConfiguration {
  selectableTextLayer: boolean;
  isPDFSinglePageViewer: boolean;
  useOnlyCssZoom: boolean;
  disableFontFace: boolean;
}

export interface IWordingConfiguration {
  document: IWordingDocumentConfiguration;
  common: IWordingCommonConfiguration;
  format: IWordingFormatConfiguration;
}

export interface IWordingDocumentConfiguration {
  editor: IWordingDocumentEditorConfiguration;
  list: IWordingDocumentListConfiguration;
  note: string;
}

export interface IWordingDocumentEditorConfiguration {
  displayTextForCalculationError: string;
  destinationNameForSendIndicator: string;
  hisInformationAlertAdditionalDescription: string;
}

export interface IWordingDocumentListConfiguration {
  status: IWordingDocumentListStatusConfiguration;
}

export interface IWordingDocumentListStatusConfiguration {
  normal: string;
}

export interface IWordingCommonConfiguration {
  department: string;
  departmentAsShort: string;
  errorViewTitle: string;
  errorViewDescription: string;
  departmentGroup: string;
}

export interface IWordingFormatConfiguration {
  name: string;
  attributes: IWordingFormatAttributesConfiguration;
}

export interface IWordingFormatAttributesConfiguration {
  company: string;
  name: string;
  masterCode: string;
}

export interface IDebugConfiguration {
  isInDevelopment: boolean;
  logger: IDebugLoggerConfiguration;
  shouldAlwaysShowObjectMenu: boolean;
  forceFormatHierarchiesEditable: boolean;
  forceDocumentFormatUpdatable: boolean;
}

export interface IDebugLoggerConfiguration {
  level: string;
  consoleAppender: IDebugLoggerAppenderConfiguration;
  ajaxAppender: IDebugLoggerAjaxAppenderConfiguration;
}

export interface IDebugLoggerAppenderConfiguration extends IEnableConfiguration {
  threshold: string;
}

export interface IDebugLoggerAjaxAppenderConfiguration extends IDebugLoggerAppenderConfiguration {
  url: string;
}

// 繰り返し使われるものは以下にinterface定義.
export interface IEnableConfiguration {
  isEnable: boolean;
}

export interface INameConfiguration {
  name: string;
}

export interface IMessageConfiguration {
  message: string;
}

export interface IResponseWaitingConfiguration {
  intervalMilliSeconds: number;
  maxCount: number;
}

export interface IPathRouteConfiguration {
  from: string;
  to: string;
}

export interface ISizeConfiguration {
  width: number;
  height: number;
}

export interface ILocationConfiguration extends ISizeConfiguration {
  top: number;
  left: number;
}

export interface IBehaviorDocumentListSelectorConfiguration extends IDefaultSelectedTabConfiguration {
  style: IBehaviorDocumentListSelectorStyleConfiguration;
}

export interface IBehaviorDocumentListSelectorStyleConfiguration {
  list: IBehaviorDocumentListSelectorStyleListConfiguration;
}

export interface IBehaviorDocumentListSelectorStyleListConfiguration {
  columns: string[];
}

export interface IDefaultSelectedTabConfiguration {
  defaultSelectedTab: string;
}

export interface IDisplayCountPerPageConfiguration {
  displayCountPerPage: number;
}

export interface IDateFormatConfiguration {
  label: string;
  format: string;
  dayOfWeekFormatPostfix: string;
  yearFormat: string;
  yearMonthFormat: string;
}

export interface ITimeFormatConfiguration {
  label: string;
  format: string;
  fuzzyFormat: string;
}

export interface IEraConfiguration {
  name: string;
  shortName: string;
  initial: string;
  origin: IEraOriginConfiguration;
}

export interface IEraOriginConfiguration {
  year: number;
  month: number;
  day: number;
}

export interface IDocumentFilterConfiguration {
  containsDeleted?: boolean;
  containsTemporary?: boolean;
  containsRegistered?: boolean;
  isLoginUserOnly?: boolean;
  isDurationDocument?: boolean;
  durationPresetName?: string;
  formatName?: string;
  formatIds?: string;
  documentKind?: string;
  documentKindIds?: string[];
  departmentCode?: string;
  updateUserCodes?: string[];
}

export interface IMaxConfiguration {
  max: number;
}

export interface IMultiSelectorConfiguration extends IMaxConfiguration {
  addition: IMultiSelectorAdditionConfiguration;
}

export interface IMultiSelectorAdditionConfiguration extends IMaxConfiguration {
}

export enum PatientProfileUpdateKinds {
  None = 0,
  NeedConfirm = 1,
  AutoRegister = 2,
  NeedConfirmIfModifiedWithBlankIgnore = 3,
  NeedConfirmIfModifiedWithBlankOverwrite = 4,
}

export interface IColorConfiguration {
  color: string;
}

export interface IBackgroundColorConfiguration {
  backgroundColor: string;
}

export function instanceOfIBackgroundColorConfiguration(instance: any): instance is IBackgroundColorConfiguration {
  return instance
    && (instance.backgroundColor !== undefined);
}

export interface IBorderColorConfiguration {
  borderColor: string;
}

export function instanceOfIBorderColorConfiguration(instance: any): instance is IBorderColorConfiguration {
  return instance
    && (instance.borderColor !== undefined);
}

export type IObjectColorConfiguration
  = IBackgroundColorConfiguration
  & IBorderColorConfiguration;

export interface IOptionSelectableObjectStyleConfiguration {
  default: IObjectColorConfiguration;
}

export interface IDropDownStyleConfiguration {
  mark: IDropDownMarkStyleConfiguration;
}

export interface IDropDownMarkStyleConfiguration {
  visibleObjectWidth: number;
}

export type IComboBoxObjectStyleConfiguration
  = IOptionSelectableObjectStyleConfiguration
  & IDropDownStyleConfiguration
  & IForegroundDisplayConfiguration;

export type IRollObjectStyleConfiguration
  = IOptionSelectableObjectStyleConfiguration
  & IForegroundDisplayConfiguration;

export interface IDefaultColorsConfiguration {
  default: IObjectColorConfiguration;
}

export interface IHisInformationApplyingColorsConfiguration {
  hisInformation: IObjectColorConfiguration;
}

export interface IUserDefinitionSelectingColorsConfiguration {
  userDefinition: IObjectColorConfiguration;
}

export interface IRelatedColorsConfiguration {
  related: IObjectColorConfiguration;
}

export interface IExternalTemplateUsingColorsConfiguration {
  mksTemplate: IObjectColorConfiguration;
  dynamicTemplate: IObjectColorConfiguration;
}

export interface INumericInputtingColorsConfiguration {
  numericInputting: IObjectColorConfiguration;
}

export interface INotEditableColorsConfiguration {
  notEditable: INotEditableColorConfiguration;
}

export interface INotEditableColorConfiguration {
  notFilledOnPrinting: IObjectColorConfiguration;
  filledOnPrinting: IObjectColorConfiguration;
}

export interface INotPrintableColorsConfiguration {
  notPrintable: IObjectColorConfiguration;
}

export interface IJoinTextApplyingColorsConfiguration {
  joinText: IObjectColorConfiguration;
}

export type IColorFixedObjectStyleConfiguration = IDefaultColorsConfiguration;

export interface ICalculateTypeColorsConfiguration {
  calculation: IObjectColorConfiguration;
  dateComparison: IObjectColorConfiguration;
  conditional: IObjectColorConfiguration;
  datePeriod: IObjectColorConfiguration;
  timePeriod: IObjectColorConfiguration;
}

export type ICalculateObjectStyleConfiguration
  = IDefaultColorsConfiguration
  & ICalculateTypeColorsConfiguration
  & IForegroundDisplayConfiguration;

export interface IBorderlessColorConfiguration {
  borderless: IObjectColorConfiguration;
}

export type ICheckBoxObjectStyleConfiguration
  = IDefaultColorsConfiguration
  & IBorderlessColorConfiguration;

export interface IDateTimeTypeColorsConfiguration {
  date: IObjectColorConfiguration;
  time: IObjectColorConfiguration;
}

export type IDateObjectStyleConfiguration
  = IDefaultColorsConfiguration
  & IHisInformationApplyingColorsConfiguration
  & IUserDefinitionSelectingColorsConfiguration
  & IDateTimeTypeColorsConfiguration
  & IForegroundDisplayConfiguration;

export interface IExternalDateObjectExtendedColorsConfiguration {
  externalData: IObjectColorConfiguration;
}

export type IExternalDataObjectStyleConfiguration
  = IDefaultColorsConfiguration
  & IExternalDateObjectExtendedColorsConfiguration
  & IForegroundDisplayConfiguration;

export type IImageObjectStyleConfiguration
  = IDefaultColorsConfiguration
  & IForegroundDisplayConfiguration;

export type ISignObjectStyleConfiguration
  = IImageObjectStyleConfiguration;

export type IMovableImageObjectStyleConfiguration
  = IForegroundDisplayConfiguration;

export type IMovableTextObjectStyleConfiguration
  = IDefaultColorsConfiguration
  & INotPrintableColorsConfiguration
  & IExternalTemplateUsingColorsConfiguration
  & IRelatedColorsConfiguration
  & IForegroundDisplayConfiguration;

export type ITextObjectStyleConfiguration
  = IDefaultColorsConfiguration
  & INumericInputtingColorsConfiguration
  & INotEditableColorsConfiguration
  & IHisInformationApplyingColorsConfiguration
  & IUserDefinitionSelectingColorsConfiguration
  & IExternalTemplateUsingColorsConfiguration
  & IRelatedColorsConfiguration
  & IForegroundDisplayConfiguration;

export type IJoinTextObjectStyleConfiguration
  = IDefaultColorsConfiguration
  & IJoinTextApplyingColorsConfiguration
  & IForegroundDisplayConfiguration;

export type IRichTextObjectStyleConfiguration
  = IDefaultColorsConfiguration
  & INotPrintableColorsConfiguration
  & IRelatedColorsConfiguration
  & IForegroundDisplayConfiguration;

export interface IForegroundDisplayConfiguration {
  foreground: IEnableConfiguration;
}

export type PdfViewType = "" | "Fit" | "FitH" | "FitV" | number;

export interface IDangerZoneConfiguration {
  document: IDangerZoneDocumentConfiguration;
}

export interface IDangerZoneDocumentConfiguration {
  factory: IDangerZoneDocumentFactoryConfiguration;
  editor: IDangerZoneDocumentEditorConfiguration;
}

export interface IDangerZoneDocumentFactoryConfiguration {
  shouldApplyValueForcibly: boolean;
}

export interface IDangerZoneDocumentEditorConfiguration {
  printingWithoutRegistration: IDangerZoneDocumentEditorPrintingWithoutRegistrationConfiguration;
  fixedPhrase: IDangerZoneDocumentEditorContentsFixedPhraseConfiguration;
  timeMeasurement: IDangerZoneDocumentEditorTimeMeasurementConfiguration;
}

export interface IDangerZoneDocumentEditorTimeMeasurementConfiguration {
  objectSets: IDangerZoneDocumentEditorTimeMeasurementObjectSetConfiguration[];
}

export interface IDangerZoneDocumentEditorTimeMeasurementObjectSetConfiguration {
  masterCodeExpression: string;
  elapsedTimeAsSecondsObjectName: string;
  startDateTimesObjectName: string;
  endDateTimesObjectName: string;
}

export interface IDangerZoneDocumentEditorPrintingWithoutRegistrationConfiguration {
  shouldCloseWindowWhenForciblyEnabled: boolean;
  closeWaitTimeAsMsec: number;
}

export interface IDangerZoneDocumentEditorContentsFixedPhraseConfiguration {
  emptyRegistrationGuard: IDangerZoneDocumentEditorContentsFixedPhraseEmptyRegistrationGuardConfiguration;
}

export interface IDangerZoneDocumentEditorContentsFixedPhraseEmptyRegistrationGuardConfiguration {
  isEnable: boolean;
  wording: string;
}

export interface INewObjectConfiguration {
  locator: INewObjectLocatorConfiguration;
}

export interface INewObjectLocatorConfiguration {
  shouldStamp: boolean;
}

export interface ICloseWindowConfirmationConfiguration {
  buttons: ICloseWindowConfirmationButtonsConfiguration;
}

export interface ICloseWindowConfirmationButtonsConfiguration {
  confirmation: INameConfiguration;
  cancellation: INameConfiguration;
}
